import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationExportsPage } from "~/pages/Settings/Organisations/organisation/exports/OrganisationExportsPage";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/exports/",
)({
  head: () => ({ meta: [{ title: i18n.t("general:documentTitle.exports") }] }),
  component: OrganisationExportsPage,
});
